// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const AnalyticsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="AnalyticsIcon" ref={forwardedRef} {...props}>
      <path d="M15.916 3.998 15.084 2.75 11 5.473 7.975 3.455 4.5 6.06V2.874H3v13a1 1 0 0 0 1 1h13v-1.5H4.5V7.936l3.525-2.644L11 7.275z" />
      <path d="M10.125 9.374h1.75v4.5h-1.75z" />
      <path d="M7.75 7.874H6v6h1.75z" />
      <path d="M14.25 6.874H16v7h-1.75z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const AnalyticsIcon = /* @__PURE__ */ Object.assign(
  AnalyticsIconComponent,
  { displayName: 'AnalyticsIcon' },
);
